import clsx from "clsx"

import { Icon, NavigationLink } from "@atoms"

import styles from "./NavBottomBarItem.module.scss"
import { NavBottomBarItemProps } from "./NavBottomBarItem.types"

export default function NavBottomBarItem(props: NavBottomBarItemProps) {
    const {
        title,
        path,
        icon,
        iconActive,
        isActive,
        isDisabled = false,
        _isFocused = false,
        _isHovered = false,
        isPressed = false,
    } = props

    return (
        <NavigationLink
            title={title}
            path={path}
            className={clsx(styles.base, {
                [styles.disabled]: isDisabled,
                [styles.focused]: _isFocused,
                [styles.hovered]: _isHovered,
                [styles.pressed]: isPressed,
            })}
            activeClassName={styles.active}
            isActive={isActive}
            isDisabled={isDisabled}
        >
            {(isActive) => (
                <Icon
                    container="fixedHeight"
                    size={18}
                    isActive={isActive}
                    icon={icon}
                    iconOnActive={iconActive}
                    className={styles.icon}
                />
            )}
        </NavigationLink>
    )
}
